module.exports = __webpack_public_path__ + "img/huazer.05e50aec.png";